import { getAxiosInstance } from "../../../np-rest/rest";
import { snackActions } from '../../../sc-utilities/SnackBar';
import { socket } from '../../../../index';

export const uploadErasureData = (data, updateProgress) => {
    const rest = getAxiosInstance();

    return async _dispatch => {
        try {

            data.append('SocketID', socket.id.split('#')[1]);

            console.log(data.get("SocketID"))
            socket.on('update-erasure-data-upload-progress', message => {
                if (message.generated === message.toGenerate) {
                    socket.off('update-erasure-data-upload-progress');
                }
                updateProgress(message);
            });
            let res = await rest.post('/offline-erase-session/upload-erasure-data', data);
            if (res.data.status === 200) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })

                return true;
            }

            if (res?.data?.result?.data instanceof Array) {
                res.data.result.data.forEach((message, index) => {
                    setTimeout(() => {
                        snackActions.snackBar({
                            message,
                            options: {
                                variant: 'warning'
                            }
                        });
                    }, index * 2000);
                });
            } else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
            }

            return false;

        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    }
}

export const fetchOrder = activeCustomerID => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('order/list', { ActiveCustomerID: activeCustomerID, listAll: true, formatForWEBUI: true, productChangePalette: true });
            return res?.data?.result?.data ?? [];
        } catch (error) {
            return [];
        }
    }
}

export const fetchTransportColli = activeCustomerID => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('transport-colli/list', { ActiveCustomerID: activeCustomerID, listAll: true, formatForWEBUI: true, productChangePalette: true });
            return res?.data?.result?.data ?? [];
        } catch (error) {
            return [];
        }
    }
}

export const fetchColli = activeCustomerID => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('colli/list', { ActiveCustomerID: activeCustomerID, listAll: true, formatForWEBUI: true, productChangePalette: true });
            return res?.data?.result?.data ?? [];
        } catch (error) {
            return [];
        }
    }
}